module.exports = __webpack_public_path__ + "1d4c7baa5e6410fca27fdc51a0ac013b.png";